// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   PROGRESS MAP - SVG Free-Form
   ============================================ */

.pmap-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-xl);
  backdrop-filter: var(--glass-blur);
}

.pmap-container::-webkit-scrollbar {
  height: 6px;
}

.pmap-container::-webkit-scrollbar-track {
  background: transparent;
}

.pmap-container::-webkit-scrollbar-thumb {
  background: var(--border-default);
  border-radius: var(--radius-sm);
}

.pmap-container::-webkit-scrollbar-thumb:hover {
  background: var(--border-strong);
}

.pmap-svg {
  display: block;
}

.pmap-svg text {
  user-select: none;
  -webkit-user-select: none;
}

/* ---- Empty state ---- */
.pmap-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  width: 100%;
  min-height: 200px;
  border: 2px dashed var(--border-default);
  border-radius: var(--radius-xl);
  background: var(--bg-card);
  color: var(--text-muted);
}

.pmap-empty-label {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
}

.pmap-empty-sub {
  font-size: var(--text-xs);
  color: var(--text-subtle);
}

/* ---- Passive dialysis pulse ---- */
.dialysis-passive-pulse {
  animation: passiveDialysisPulse 2.5s ease-in-out infinite;
}

@keyframes passiveDialysisPulse {
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.1); }
}

/* ---- Accessibility ---- */
@media (prefers-reduced-motion: reduce) {
  .pmap-svg g {
    transition: none !important;
  }
  .dialysis-passive-pulse {
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProgressMap/ProgressMap.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wCAAwC;EACxC,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,4BAA4B;EAC5B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C;;AAEA,4BAA4B;AAC5B;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================\n   PROGRESS MAP - SVG Free-Form\n   ============================================ */\n\n.pmap-container {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-xl);\n  backdrop-filter: var(--glass-blur);\n}\n\n.pmap-container::-webkit-scrollbar {\n  height: 6px;\n}\n\n.pmap-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.pmap-container::-webkit-scrollbar-thumb {\n  background: var(--border-default);\n  border-radius: var(--radius-sm);\n}\n\n.pmap-container::-webkit-scrollbar-thumb:hover {\n  background: var(--border-strong);\n}\n\n.pmap-svg {\n  display: block;\n}\n\n.pmap-svg text {\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n/* ---- Empty state ---- */\n.pmap-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-3);\n  width: 100%;\n  min-height: 200px;\n  border: 2px dashed var(--border-default);\n  border-radius: var(--radius-xl);\n  background: var(--bg-card);\n  color: var(--text-muted);\n}\n\n.pmap-empty-label {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wide);\n}\n\n.pmap-empty-sub {\n  font-size: var(--text-xs);\n  color: var(--text-subtle);\n}\n\n/* ---- Passive dialysis pulse ---- */\n.dialysis-passive-pulse {\n  animation: passiveDialysisPulse 2.5s ease-in-out infinite;\n}\n\n@keyframes passiveDialysisPulse {\n  0%, 100% { opacity: 0.6; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.1); }\n}\n\n/* ---- Accessibility ---- */\n@media (prefers-reduced-motion: reduce) {\n  .pmap-svg g {\n    transition: none !important;\n  }\n  .dialysis-passive-pulse {\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
